import React from 'react'
import { createRoot } from 'react-dom/client'
import './Styles/layers.css'
import './index.scss'
import '@edvi-tech/ui/styles.css'
import './Styles/app.css'
/* Load SDK embed CSS after app layers so course player utilities win */
import '@edvi-tech/skills-sdk/embed.css'
import './Styles/topnav-menu.css'
import './Styles/pointers.css'
import { Toaster } from 'sonner'
import chromeOverrides from './Styles/chrome-overrides.css?raw'
import batchQuizAttemptsOverrides from './Styles/app/batch-quiz-attempts.css?raw'
import {
  ensureSkillsInitialized,
  createClassroomAuthAdapter,
} from '@edvi-tech/skills-sdk'
import { ThemeProvider as NextThemesProvider } from 'next-themes'
import util from 'util'
import inherits from 'inherits'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { signInFirebase } from './firebase/firebase'

function appendChromeOverrides() {
  const id = 'edvi-chrome-overrides'
  document.getElementById(id)?.remove()
  const el = document.createElement('style')
  el.id = id
  el.textContent = `${chromeOverrides}\n${batchQuizAttemptsOverrides}`
  document.head.appendChild(el)
}

appendChromeOverrides()

window.util = util
util.inherits = inherits
window.util.inherits = inherits

ensureSkillsInitialized({
  api: { baseUrl: import.meta.env.VITE_BASE_URL },
  auth: createClassroomAuthAdapter({
    onUnauthorized: () => {
      window.location.href = '/auth/login'
    },
  }),
})

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <React.StrictMode>
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
    >
      <App />
      <Toaster
        theme="light"
        closeButton
        position="bottom-center"
        visibleToasts={4}
        className="edvi-toaster"
        toastOptions={{
          className: 'edvi-toast',
          classNames: {
            toast: 'edvi-toast',
            title: 'edvi-toast__title',
            success: 'edvi-toast--success',
            error: 'edvi-toast--error',
            info: 'edvi-toast--info',
            warning: 'edvi-toast--warning',
            closeButton: 'edvi-toast__close',
          },
        }}
        style={{ zIndex: 2147483646 }}
      />
    </NextThemesProvider>
  </React.StrictMode>,
)

signInFirebase()
reportWebVitals()
